import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import Box from "@mui/material/Box";
import UserManagmentTable from '../Admin/User/UserManagementTable';
import AuthRoute from '../Authorisation/AuthRoute';
import UserProfileForm from '../Admin/User/UserProfileEdit';
import CreateOrganisationForm from '../Licensing/Organisation/CreateOrganisation';
import Calendar from '../Licensing/Calendar/Calendar';
import ModifyOrganisation from '../Licensing/Organisation/ModifyOrganisation';
import TitleBar from '../Navigation/TitleBar';
import AuthContainer from '../Authorisation/AuthContainer';
import Login from '../Authorisation/Login';
import ForgotPassword from '../Authorisation/ForgotPassword';
import ResetPassword from '../Authorisation/ResetPassword';
import Home from '../Navigation/Home';
import RegisterUser from '../Authorisation/RegisterUser';
import SiteTable from '../Site/SiteTable/SiteTable';
import Help from '../Help/Help';
import Settings from '../Settings/Settings';
import Library from '../Library/Library';
import Site from '../Site/Site';
import SideNav from '../Navigation/SideNav';
import AccountPage from '../User/AccountPage';
import SavedSessionContainer from '../Sessions/SavedSessionContainer';
import RankOrderPage from '../TripRate/RankOrderList/RankOrderPage';
import MyOrganisation from '../Management/Organisations/MyOrganisation';
import ManageOrganisations from '../Management/Organisations/ManageOrganisations';
import Admin from '../Admin/Admin';
import TripRateCalculationPage from '../TripRate/Calculation/TripRateCalculationPage';
import { TripRateProvider } from '../TripRate/TripRateContext';
import TripRateLayout from '../TripRate/TripRateLayout';
import TimeSeriesAnalysisContainer from '../TimeSeriesAnalysis/TimeSeriesAnalysisContainer';
import SoftwareArchive from '../AdditionalContent/SoftwareArchive';
import MyFilesContainer from '../Files/MyFilesContainer';
import QuickAccess from './QuickAccess';
import TRAVL from '../AdditionalContent/TRAVL/TRAVL';
import TravlSurveyTable from '../AdditionalContent/TRAVL/TravlSurveyTable';
import TravlLayout from '../AdditionalContent/TRAVL/TravlLayout';
import Cambourne from '../AdditionalContent/Cambourne/Camborne';
import AdditionalLinks from '../AdditionalContent/AdditionalLinks';
import ExtractionPage from '../AdditionalContent/TRAVL/ExtractionPage';
import SiteFiltering from '../TripRate/Filters/SiteFiltering';
import OrganisationsContextProvider from '../Contexts/OrganisationsContext';
import LegacyFilesContainer from '../Files/LegacyFilesContainer';
import LandusePage from '../TripRateNew/LandusePage';
import ParameterFiltering from '../TripRateNew/ParamterFiltering';
import SiteCharacteristics from '../TripRateNew/SiteCharacteristics';
import PopulationFiltering from '../TripRateNew/PopulationCharacteristics';
import TripRateSummary from '../TripRate/Filters/Summary/TripRateSummary';
import TelemetryExportPage from '../Admin/TelemetryExportPage';
import InvoiceExportPage from '../Admin/InvoiceExportPage';
import MailchimpRequestsPage from '../Admin/MailchimpRequestsPage';
import ManagerUserChangesPage from '../Admin/ManagerUserChangesPage';
import UsageReportsPage from '../Admin/UsageReportsPage';
import AdminRoute from '../Authorisation/AdminRoute';
import SuperadminDashboard from '../Admin/SuperadminDashboard';
import SuperAdminRoute from '../Authorisation/SuperAdminRoute';

export default function NavigationContainer() {
    return (
        <Box display="flex" flexDirection="column" height="100vh" overflow="hidden">
            <Routes>
                <Route element={<TitleBar />}>
                    <Route path={'authorisation'} element={<AuthContainer />}>
                        <Route path={'login'} element={<Login />} />
                        <Route path={'forgotpassword'} element={<ForgotPassword />} />
                        <Route path={'resetpassword'} element={<ResetPassword />} />
                        <Route path={'registerconfirmation'} element={<RegisterUser />} />
                    </Route>
                    <Route element={<AuthRoute><SideNav /></AuthRoute>}>
                        <Route path={'cambourne'} element={<Cambourne />} />
                        <Route path={'additionallinks'} element={<AdditionalLinks />} />
                        <Route path={'home'} element={<Home />} />
                        <Route path={'sitelist'} element={<SiteTable type={'siteList'} />} />
                        <Route path={'savedreports'} element={<MyFilesContainer />} />
                        <Route path={'legacyfiles'} element={<LegacyFilesContainer />} />

                        <Route path="travl" element={<TravlLayout />}>
                            <Route path="home" element={<TRAVL />} />
                            <Route path="surveyTable" element={<TravlSurveyTable />} />
                            <Route path='extract' element={<ExtractionPage />} />
                        </Route>

                        <Route path={'triprate'} element={<TripRateProvider><TripRateLayout /></TripRateProvider>}>
                            <Route path="landuse" element={<LandusePage />} />
                            <Route path='filter' element={<SiteFiltering />} />
                            <Route path="params" element={<ParameterFiltering />} />
                            <Route path="characteristics" element={<SiteCharacteristics />} />
                            <Route path="population" element={<PopulationFiltering />} />
                            <Route path="summary" element={<TripRateSummary />} />
                            <Route path='results' element={<TripRateCalculationPage />} />
                            <Route path='rankorder' element={<RankOrderPage />} />
                            <Route index element={<Navigate to="landuse" replace />} />
                        </Route>

                        <Route path={'timeseriesanalysis'} element={<TimeSeriesAnalysisContainer />} />
                        <Route path={'site'} element={<Site />} />
                        <Route path={'help'} element={<Help />} />
                        <Route path={'library'} element={<Library />} />
                        <Route path={'settings'} element={<Settings />} />
                        <Route path={'savedsessions'} element={<SavedSessionContainer />} />
                        <Route path={'softwarearchive'} element={<SoftwareArchive />} />
                        <Route path={'myaccount'} element={<AccountPage />} />
                        <Route path={'myorganisation'} element={<MyOrganisation />} />
                        <Route path={'admin'} element={<AdminRoute />}>
                            <Route element={<OrganisationsContextProvider><Outlet /></OrganisationsContextProvider>}>
                                <Route path={'manageorganisations'} element={<ManageOrganisations />} />
                                <Route path={'manageorganisation'} element={<ModifyOrganisation />} />
                            </Route>
                            <Route path={'createorganisation'} element={<CreateOrganisationForm />} />
                            <Route path={'usermanagment'} element={<UserManagmentTable />} />
                            <Route path={'updateuser'} element={<UserProfileForm />} />
                            <Route path={'Calendar'} element={<Calendar />} />
                            <Route path={'DeviceActivity'} element={<TelemetryExportPage />} />
                            <Route path={'deviceactivity'} element={<TelemetryExportPage />} />
                            <Route path={'invoiceexports'} element={<InvoiceExportPage />} />
                            <Route path={'usagereports'} element={<UsageReportsPage />} />
                            <Route path={'mailchimprequests'} element={<MailchimpRequestsPage />} />
                            <Route path={'manageruserchanges'} element={<ManagerUserChangesPage />} />
                            <Route element={<SuperAdminRoute />}>
                                <Route path={'superadmin'} element={<SuperadminDashboard />} />
                            </Route>
                            <Route index element={<Admin />} />
                        </Route>
                    </Route>
                    <Route path={'quickaccess'} element={<QuickAccess />} />
                    <Route path="*" element={<Navigate to="home" replace />} />
                </Route>
            </Routes>
        </Box >
    );
}
